import Frozen from "terriajs-cesium/Source/Core/Frozen";
import getTimestamp from "terriajs-cesium/Source/Core/getTimestamp";
const pollToPromise = function (f, options) {
  var _options$pollInterval, _options$timeout;
  options = options !== null && options !== void 0 ? options : Frozen.EMPTY_OBJECT;
  const pollInterval = (_options$pollInterval = options.pollInterval) !== null && _options$pollInterval !== void 0 ? _options$pollInterval : 1;
  const timeout = (_options$timeout = options.timeout) !== null && _options$timeout !== void 0 ? _options$timeout : 5000;
  return new Promise((resolve, reject) => {
    const startTimestamp = getTimestamp();
    const endTimestamp = startTimestamp + timeout;
    function poller() {
      if (f()) {
        resolve();
      } else {
        if (getTimestamp() > endTimestamp) {
          reject();
        } else {
          setTimeout(poller, pollInterval);
        }
      }
    }
    poller();
  });
};
export default pollToPromise;